window.brImages = { with: null, without: null };
window.brSelectedMode = "with";

/* Dynamic Mockup URL */
window.brMockupUrl = null;

/* Overlay in aktives Slide setzen */
function moveOverlayToActiveSlide() {

  /* Wenn Dynamic Mockup aktiv → Overlay entfernen */
  if (window.brMockupUrl) {
    const existing = document.querySelector(".br-overlay");
    if (existing) existing.remove();
    return;
  }

  const activeSlide = document.querySelector("li.product-media-item.is-active");
  if (!activeSlide) return;

  let overlay = document.querySelector(".br-overlay");

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "br-overlay";

    const img = document.createElement("img");
    img.id = "brDesignLayer";
    img.className = "br-design-layer";
    img.alt = "";

    overlay.appendChild(img);
  }

  const mediaContainer = activeSlide.querySelector(".product-media-container");
  if (!mediaContainer) return;

  mediaContainer.appendChild(overlay);

  applyImage();
}

/* Bild anwenden */
function applyImage() {

  /* Wenn Mockup aktiv → nichts tun */
  if (window.brMockupUrl) return;

  const img = document.getElementById("brDesignLayer");
  if (!img) return;

  const url = window.brImages?.[window.brSelectedMode];
  if (url) img.src = url;
}

/* Wird vom Generator aufgerufen */
window.setBackgroundRemoverImages = function(withBgUrl, withoutBgUrl) {

  /* Mockup deaktivieren */
  window.brMockupUrl = null;

  window.brImages.with = withBgUrl;
  window.brImages.without = withoutBgUrl;
  window.brSelectedMode = "with";

  moveOverlayToActiveSlide();
};

/* Wird vom Dynamic Mockup benutzt */
window.setDynamicMockupImage = function(mockupUrl) {

  window.brMockupUrl = mockupUrl;

  const img = document.querySelector(".product-media-container img");
  if (img) {
    img.src = mockupUrl + "?v=" + Date.now();
  }

  const overlay = document.querySelector(".br-overlay");
  if (overlay) overlay.remove();
};

/* Toggle */
document.addEventListener("click", function(e) {

  if (window.brMockupUrl) return;

  const btn = e.target.closest("[data-br-toggle]");
  if (!btn) return;

  const mode = btn.dataset.brToggle;
  if (!window.brImages[mode]) return;

  window.brSelectedMode = mode;
  applyImage();
});

/* Reagiert auf Farbwechsel */
document.addEventListener("change", function(e) {

  if (!e.target.closest("form[action*='/cart/add']")) return;

  setTimeout(function() {
    moveOverlayToActiveSlide();
  }, 80);

});

/* Initial */
document.addEventListener("DOMContentLoaded", function() {
  moveOverlayToActiveSlide();
});